import React, {useState} from 'react';
import { Switch, Route } from 'react-router-dom';

import TACategorias from "../../Pages/Admin/TACategoria";
import TAExercicios from "../../Pages/Admin/TAExercicios";
import TAClientes from "../../Pages/Admin/TAClientes";
import TARecebimentos from "../../Pages/Admin/TARecebimentos";
import TARepresentantes from "../../Pages/Admin/TARepresentantes";
import TAPagamentos from '../../Pages/Admin/TAPagamentos';
import TAAlunos from '../../Pages/Admin/TAAlunos';
import TAInicio from '../../Pages/Admin/TAInicio';
import TATreinos from '../../Pages/Admin/TATreinos';
import TARecebimentosAlunos from '../../Pages/Admin/TARecebimentosAlunos';
import TAPagamentosClientes from '../../Pages/Admin/TAPagamentosClientes';
import TAMedidasAluno from '../../Pages/Admin/TAMedidasAluno';
import TAHistoricoAluno from '../../Pages/Admin/TAHistoricoAluno';
import TAFuncionariosClientes from '../../Pages/Admin/TAFuncionariosClientes';
import TAMensagem from '../../Pages/Admin/TAMensagem';
import TAPermissoesClientes from '../../Pages/Admin/TAPermissoesClientes';
import TAAcaoFuncionario from '../../Pages/Admin/TAAcaoFuncionario';






export default ({InfIdUse, InfIdConta,  IdConta, DadCont, DadEmp, Dados, IdUse, CidEst,  setDados, Loading,  setLoading,  Alert, setAlert, AlertTipo, setAlertTipo, Avisando, setAvisando }) => {

  
    return (
        <Switch>
            {(DadCont === "Cliente" || DadCont === "Fun")  &&
            <>
            {Dados &&
                        <>
                        {Dados.Acões.Ver &&
                        <>
                         <Route exact path= "/Acoes">
                            <TAAcaoFuncionario
                                InfIdConta={InfIdConta}
                                InfIdUse={InfIdUse}
                                DadCont={DadCont}
                                IdConta={IdConta}
                                IdUse={IdUse}
                                Dados={Dados}
                                CidEst={CidEst}
                                setDados={setDados}
                                Loading={Loading}
                                setLoading={setLoading}
                                Alert={Alert}
                                setAlert={setAlert}
                                AlertTipo={AlertTipo}
                                setAlertTipo={setAlertTipo}
                                Avisando={Avisando}
                                setAvisando={setAvisando}
                            />
                        </Route>
                        </>
                        }
                        </>
                        }
             {Dados &&
                        <>
                        {Dados.Alunos.Ver &&
                        <>
                         <Route exact path= "/Alunos">
                            <TAAlunos
                                InfIdConta={InfIdConta}
                                InfIdUse={InfIdUse}
                                DadCont={DadCont}
                                IdConta={IdConta}
                                IdUse={IdUse}
                                Dados={Dados}
                                CidEst={CidEst}
                                setDados={setDados}
                                Loading={Loading}
                                setLoading={setLoading}
                                Alert={Alert}
                                setAlert={setAlert}
                                AlertTipo={AlertTipo}
                                setAlertTipo={setAlertTipo}
                                Avisando={Avisando}
                                setAvisando={setAvisando}
                            />
                        </Route>
                        </>
                        }
                        </>
                        }
                         {Dados &&
                        <>
                        {Dados.Categorias.Ver &&
                        <>
                          <Route exact path= "/Categorias">
                            <TACategorias
                                InfIdConta={InfIdConta}
                                InfIdUse={InfIdUse}
                                DadCont={DadCont}
                                IdConta={IdConta}
                                IdUse={IdUse}
                                CidEst={CidEst}
                                Dados={Dados}
                                setDados={setDados}
                                Loading={Loading}
                                setLoading={setLoading}
                                Alert={Alert}
                                setAlert={setAlert}
                                AlertTipo={AlertTipo}
                                setAlertTipo={setAlertTipo}
                                Avisando={Avisando}
                                setAvisando={setAvisando}
                            />
                        </Route>
                        </>
                        }
                        </>
                        }
                      {Dados &&
                        <>
                        {Dados.Exercícios.Ver &&
                        <>
                          <Route exact path= "/Exercicios">
                            <TAExercicios
                                InfIdConta={InfIdConta}
                                InfIdUse={InfIdUse}
                                DadCont={DadCont}
                                IdConta={IdConta}
                                IdUse={IdUse}
                                CidEst={CidEst}
                                Dados={Dados}
                                setDados={setDados}
                                Loading={Loading}
                                setLoading={setLoading}
                                Alert={Alert}
                                setAlert={setAlert}
                                AlertTipo={AlertTipo}
                                setAlertTipo={setAlertTipo}
                                Avisando={Avisando}
                                setAvisando={setAvisando}
                            />
                        </Route>
                        </>
                        }
                        </>
                        }
                         {Dados &&
                        <>
                        {Dados.Treinos.Ver &&
                        <>
                           <Route exact path= "/Treinos">
                            <TATreinos
                                InfIdConta={InfIdConta}
                                InfIdUse={InfIdUse}
                                DadCont={DadCont}
                                IdConta={IdConta}
                                IdUse={IdUse}
                                CidEst={CidEst}
                                Dados={Dados}
                                setDados={setDados}
                                Loading={Loading}
                                setLoading={setLoading}
                                Alert={Alert}
                                setAlert={setAlert}
                                AlertTipo={AlertTipo}
                                setAlertTipo={setAlertTipo}
                                Avisando={Avisando}
                                setAvisando={setAvisando}
                            />
                        </Route>
                        </>
                        }
                        </>
                        }
                            
                        {Dados &&
                        <>
                        {Dados.Recebimentos.Ver &&
                        <>
                         <Route exact path= "/RecebimentosAlunos">
                        <TARecebimentosAlunos
                            InfIdConta={InfIdConta}
                            InfIdUse={InfIdUse}
                            DadCont={DadCont}
                            IdConta={IdConta}
                            IdUse={IdUse}
                            CidEst={CidEst}
                            Dados={Dados}
                            setDados={setDados}
                            Loading={Loading}
                            setLoading={setLoading}
                            Alert={Alert}
                            setAlert={setAlert}
                            AlertTipo={AlertTipo}
                            setAlertTipo={setAlertTipo}
                            Avisando={Avisando}
                            setAvisando={setAvisando}
                        />
                    </Route>
                        </>
                        }
                        </>
                        } 
                       {Dados &&
                        <>
                        {Dados.Pagamentos.Ver &&
                        <>
                        <Route exact path= "/PagamentosEmpresa">
                        <TAPagamentosClientes
                            InfIdConta={InfIdConta}
                            InfIdUse={InfIdUse}
                            DadCont={DadCont}
                            IdConta={IdConta}
                            IdUse={IdUse}
                            CidEst={CidEst}
                            Dados={Dados}
                            setDados={setDados}
                            Loading={Loading}
                            setLoading={setLoading}
                            Alert={Alert}
                            setAlert={setAlert}
                            AlertTipo={AlertTipo}
                            setAlertTipo={setAlertTipo}
                            Avisando={Avisando}
                            setAvisando={setAvisando}
                        />
                    </Route>
                        </>
                        }
                        </>
                        } 
                        {Dados &&
                        <>
                        {Dados.Medidas.Ver &&
                        <>
                        <Route exact path= "/MedidasAlunos">
                        <TAMedidasAluno
                            InfIdConta={InfIdConta}
                            InfIdUse={InfIdUse}
                            DadCont={DadCont}
                            IdConta={IdConta}
                            IdUse={IdUse}
                            CidEst={CidEst}
                            Dados={Dados}
                            setDados={setDados}
                            Loading={Loading}
                            setLoading={setLoading}
                            Alert={Alert}
                            setAlert={setAlert}
                            AlertTipo={AlertTipo}
                            setAlertTipo={setAlertTipo}
                            Avisando={Avisando}
                            setAvisando={setAvisando}
                        />
                    </Route>
                        </>
                        }
                        </>
                        } 
                         {Dados &&
                        <>
                        {Dados.Histórico.Ver &&
                        <>
                        <Route exact path= "/HistoricoAlunos">
                            <TAHistoricoAluno
                                InfIdConta={InfIdConta}
                                InfIdUse={InfIdUse}
                                DadCont={DadCont}
                                IdConta={IdConta}
                                IdUse={IdUse}
                                CidEst={CidEst}
                                Dados={Dados}
                                setDados={setDados}
                                Loading={Loading}
                                setLoading={setLoading}
                                Alert={Alert}
                                setAlert={setAlert}
                                AlertTipo={AlertTipo}
                                setAlertTipo={setAlertTipo}
                                Avisando={Avisando}
                                setAvisando={setAvisando}
                            />
                        </Route>
                        </>
                        }
                        </>
                        } 
                         {Dados &&
                        <>
                        {Dados.Funcionários.Ver &&
                        <>
                        <Route exact path= "/Funcionarios">
                            <TAFuncionariosClientes
                                InfIdConta={InfIdConta}
                                InfIdUse={InfIdUse}
                                DadCont={DadCont}
                                IdConta={IdConta}
                                IdUse={IdUse}
                                CidEst={CidEst}
                                Dados={Dados}
                                setDados={setDados}
                                Loading={Loading}
                                setLoading={setLoading}
                                Alert={Alert}
                                setAlert={setAlert}
                                AlertTipo={AlertTipo}
                                setAlertTipo={setAlertTipo}
                                Avisando={Avisando}
                                setAvisando={setAvisando}
                            />
                        </Route>
                        </>
                        }
                        </>
                        } 
                        {Dados &&
                        <>
                        {Dados.Permissões.Ver &&
                        <>
                           <Route exact path= "/Permissoes">
                            <TAPermissoesClientes
                                InfIdConta={InfIdConta}
                                InfIdUse={InfIdUse}
                                DadCont={DadCont}
                                IdConta={IdConta}
                                IdUse={IdUse}
                                CidEst={CidEst}
                                Dados={Dados}
                                setDados={setDados}
                                Loading={Loading}
                                setLoading={setLoading}
                                Alert={Alert}
                                setAlert={setAlert}
                                AlertTipo={AlertTipo}
                                setAlertTipo={setAlertTipo}
                                Avisando={Avisando}
                                setAvisando={setAvisando}
                            />
                        </Route>
                        </>
                        }
                        </>
                        } 
                        
                         {Dados &&
                        <>
                        {Dados.Avisos.Ver &&
                        <>
                        <Route exact path= "/Avisos">
                            <TAMensagem
                                InfIdConta={InfIdConta}
                                InfIdUse={InfIdUse}
                                DadCont={DadCont}
                                IdConta={IdConta}
                                IdUse={IdUse}
                                CidEst={CidEst}
                                Dados={Dados}
                                setDados={setDados}
                                Loading={Loading}
                                setLoading={setLoading}
                                Alert={Alert}
                                setAlert={setAlert}
                                AlertTipo={AlertTipo}
                                setAlertTipo={setAlertTipo}
                                Avisando={Avisando}
                                setAvisando={setAvisando}
                            />
                        </Route>
                        </>
                        }
                        </>
                        } 
                        {Dados &&
                        <>
                        {Dados.Acões.Ver &&
                        <>
                       
                        </>
                        }
                        </>
                        } 
          
            
            
           
             
             
           
           
             <Route exact path= "/">
                <TAInicio
                    InfIdConta={InfIdConta}
                    InfIdUse={InfIdUse}
                    DadCont={DadCont}
                    IdConta={IdConta}
                    IdUse={IdUse}
                    CidEst={CidEst}
                    Dados={Dados}
                    setDados={setDados}
                    Loading={Loading}
                    setLoading={setLoading}
                    Alert={Alert}
                    setAlert={setAlert}
                    AlertTipo={AlertTipo}
                    setAlertTipo={setAlertTipo}
                    Avisando={Avisando}
                    setAvisando={setAvisando}
                />
            </Route>
            
            
          
            </>
            }
            {DadCont === "Emp" &&
            <>
            {Dados &&
                        <>
                        {Dados.Acões.Ver &&
                        <>
                         <Route exact path= "/Acoes">
                            <TAAcaoFuncionario
                                InfIdConta={InfIdConta}
                                InfIdUse={InfIdUse}
                                DadCont={DadCont}
                                IdConta={IdConta}
                                IdUse={IdUse}
                                Dados={Dados}
                                CidEst={CidEst}
                                setDados={setDados}
                                Loading={Loading}
                                setLoading={setLoading}
                                Alert={Alert}
                                setAlert={setAlert}
                                AlertTipo={AlertTipo}
                                setAlertTipo={setAlertTipo}
                                Avisando={Avisando}
                                setAvisando={setAvisando}
                            />
                        </Route>
                        </>
                        }
                        </>
                        }
             {Dados &&
                <>
                {Dados.Funcionários.Ver &&
                <>
                <Route exact path= "/Funcionarios">
                    <TAFuncionariosClientes
                        InfIdConta={InfIdConta}
                        InfIdUse={InfIdUse}
                        DadCont={DadCont}
                        IdConta={IdConta}
                        IdUse={IdUse}
                        CidEst={CidEst}
                        Dados={Dados}
                        setDados={setDados}
                        Loading={Loading}
                        setLoading={setLoading}
                        Alert={Alert}
                        setAlert={setAlert}
                        AlertTipo={AlertTipo}
                        setAlertTipo={setAlertTipo}
                        Avisando={Avisando}
                        setAvisando={setAvisando}
                    />
                </Route>
                </>
                }
                </>
                } 
                {Dados &&
                <>
                {Dados.Permissões.Ver &&
                <>
                    <Route exact path= "/Permissoes">
                    <TAPermissoesClientes
                        InfIdConta={InfIdConta}
                        InfIdUse={InfIdUse}
                        DadCont={DadCont}
                        IdConta={IdConta}
                        IdUse={IdUse}
                        CidEst={CidEst}
                        Dados={Dados}
                        setDados={setDados}
                        Loading={Loading}
                        setLoading={setLoading}
                        Alert={Alert}
                        setAlert={setAlert}
                        AlertTipo={AlertTipo}
                        setAlertTipo={setAlertTipo}
                        Avisando={Avisando}
                        setAvisando={setAvisando}
                    />
                </Route>
                </>
                }
                </>
                } 
            {Dados &&
                        <>
                        {Dados.Histórico.Ver &&
                        <>
                        <Route exact path= "/HistoricoAlunos">
                            <TAHistoricoAluno
                                InfIdConta={InfIdConta}
                                InfIdUse={InfIdUse}
                                DadCont={DadCont}
                                IdConta={IdConta}
                                IdUse={IdUse}
                                CidEst={CidEst}
                                Dados={Dados}
                                setDados={setDados}
                                Loading={Loading}
                                setLoading={setLoading}
                                Alert={Alert}
                                setAlert={setAlert}
                                AlertTipo={AlertTipo}
                                setAlertTipo={setAlertTipo}
                                Avisando={Avisando}
                                setAvisando={setAvisando}
                            />
                        </Route>
                        </>
                        }
                        </>
                        }
             {Dados &&
                        <>
                        {Dados.Medidas.Ver &&
                        <>
                        <Route exact path= "/MedidasAlunos">
                        <TAMedidasAluno
                            InfIdConta={InfIdConta}
                            InfIdUse={InfIdUse}
                            DadCont={DadCont}
                            IdConta={IdConta}
                            IdUse={IdUse}
                            CidEst={CidEst}
                            Dados={Dados}
                            setDados={setDados}
                            Loading={Loading}
                            setLoading={setLoading}
                            Alert={Alert}
                            setAlert={setAlert}
                            AlertTipo={AlertTipo}
                            setAlertTipo={setAlertTipo}
                            Avisando={Avisando}
                            setAvisando={setAvisando}
                        />
                    </Route>
                        </>
                        }
                        </>
                        } 

             {Dados &&
                        <>
                        {Dados.Recebimentos.Ver &&
                        <>
                         <Route exact path= "/RecebimentosAlunos">
                        <TARecebimentosAlunos
                            InfIdConta={InfIdConta}
                            InfIdUse={InfIdUse}
                            DadCont={DadCont}
                            IdConta={IdConta}
                            IdUse={IdUse}
                            CidEst={CidEst}
                            Dados={Dados}
                            setDados={setDados}
                            Loading={Loading}
                            setLoading={setLoading}
                            Alert={Alert}
                            setAlert={setAlert}
                            AlertTipo={AlertTipo}
                            setAlertTipo={setAlertTipo}
                            Avisando={Avisando}
                            setAvisando={setAvisando}
                        />
                    </Route>
                        </>
                        }
                        </>
                        }
             {Dados &&
                        <>
                         {Dados.Alunos &&
                         <>
                        {Dados.Alunos.Ver &&
                        <>
                         <Route exact path= "/Alunos">
                            <TAAlunos
                                InfIdConta={InfIdConta}
                                InfIdUse={InfIdUse}
                                DadCont={DadCont}
                                IdConta={IdConta}
                                IdUse={IdUse}
                                Dados={Dados}
                                CidEst={CidEst}
                                setDados={setDados}
                                Loading={Loading}
                                setLoading={setLoading}
                                Alert={Alert}
                                setAlert={setAlert}
                                AlertTipo={AlertTipo}
                                setAlertTipo={setAlertTipo}
                                Avisando={Avisando}
                                setAvisando={setAvisando}
                            />
                        </Route>
                        </>
                        }
                         </>
                        }
                        </>
                        }
            
            
            <Route exact path= "/Pagamentos">
                <TAPagamentos
                    DadCont={DadCont}
                    IdConta={IdConta}
                    IdUse={IdUse}
                    CidEst={CidEst}
                    Dados={Dados}
                    setDados={setDados}
                    Loading={Loading}
                    setLoading={setLoading}
                    Alert={Alert}
                    setAlert={setAlert}
                    AlertTipo={AlertTipo}
                    setAlertTipo={setAlertTipo}
                    Avisando={Avisando}
                    setAvisando={setAvisando}
                />
            </Route>
            <Route exact path= "/Representantes">
                <TARepresentantes
                    DadCont={DadCont}
                    IdConta={IdConta}
                    IdUse={IdUse}
                    CidEst={CidEst}
                    Dados={Dados}
                    setDados={setDados}
                    Loading={Loading}
                    setLoading={setLoading}
                    Alert={Alert}
                    setAlert={setAlert}
                    AlertTipo={AlertTipo}
                    setAlertTipo={setAlertTipo}
                    Avisando={Avisando}
                    setAvisando={setAvisando}
                />
            </Route>
            <Route exact path= "/Categorias">
                <TACategorias
                    DadCont={DadCont}
                    IdConta={IdConta}
                    IdUse={IdUse}
                    CidEst={CidEst}
                    Dados={Dados}
                    setDados={setDados}
                    Loading={Loading}
                    setLoading={setLoading}
                    Alert={Alert}
                    setAlert={setAlert}
                    AlertTipo={AlertTipo}
                    setAlertTipo={setAlertTipo}
                    Avisando={Avisando}
                    setAvisando={setAvisando}
                />
            </Route>
            <Route exact path= "/Exercicios">
                <TAExercicios
                    DadCont={DadCont}
                    IdConta={IdConta}
                    IdUse={IdUse}
                    CidEst={CidEst}
                    Dados={Dados}
                    setDados={setDados}
                    Loading={Loading}
                    setLoading={setLoading}
                    Alert={Alert}
                    setAlert={setAlert}
                    AlertTipo={AlertTipo}
                    setAlertTipo={setAlertTipo}
                    Avisando={Avisando}
                    setAvisando={setAvisando}
                />
            </Route>
            <Route exact path= "/Clientes">
                <TAClientes
                    DadCont={DadCont}
                    IdConta={IdConta}
                    IdUse={IdUse}
                    CidEst={CidEst}
                    Dados={Dados}
                    setDados={setDados}
                    Loading={Loading}
                    setLoading={setLoading}
                    Alert={Alert}
                    setAlert={setAlert}
                    AlertTipo={AlertTipo}
                    setAlertTipo={setAlertTipo}
                    Avisando={Avisando}
                    setAvisando={setAvisando}
                />
            </Route>
             <Route exact path= "/Recebimentos">
                <TARecebimentos
                    DadCont={DadCont}
                    IdConta={IdConta}
                    IdUse={IdUse}
                    CidEst={CidEst}
                    Dados={Dados}
                    setDados={setDados}
                    Loading={Loading}
                    setLoading={setLoading}
                    Alert={Alert}
                    setAlert={setAlert}
                    AlertTipo={AlertTipo}
                    setAlertTipo={setAlertTipo}
                    Avisando={Avisando}
                    setAvisando={setAvisando}
                />
            </Route>
             {Dados &&
                        <>
                        {Dados.Treinos.Ver &&
                        <>
                           <Route exact path= "/Treinos">
                            <TATreinos
                                InfIdConta={InfIdConta}
                                InfIdUse={InfIdUse}
                                DadCont={DadCont}
                                IdConta={IdConta}
                                IdUse={IdUse}
                                CidEst={CidEst}
                                Dados={Dados}
                                setDados={setDados}
                                Loading={Loading}
                                setLoading={setLoading}
                                Alert={Alert}
                                setAlert={setAlert}
                                AlertTipo={AlertTipo}
                                setAlertTipo={setAlertTipo}
                                Avisando={Avisando}
                                setAvisando={setAvisando}
                            />
                        </Route>
                        </>
                        }
                        </>
                        }
            </>
            }
              
            
           
          
            
           
            
        </Switch>
    )
}